// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../../common/http.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var Highcharts$ReactHooksTemplate = require("../../common/Highcharts.res.js");
var InsightsFilters$ReactHooksTemplate = require("../filters/InsightsFilters.res.js");

function reducer(state, x) {
  if (typeof x !== "object") {
    switch (x) {
      case "ToggleFilter" :
          return {
                  loadingCorrelationData: state.loadingCorrelationData,
                  toggleFilter: !state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      case "FetchFiltersInProgress" :
      case "FetchCorrelationDataInProgress" :
          break;
      
    }
  } else {
    switch (x.TAG) {
      case "FetchedCorrelationData" :
          return {
                  loadingCorrelationData: state.loadingCorrelationData,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: state.filters,
                  currentFilter: state.currentFilter,
                  correlationData: x._0
                };
      case "SetFiltersAndPills" :
          return {
                  loadingCorrelationData: true,
                  toggleFilter: state.toggleFilter,
                  filterPills: x._1,
                  filters: x._0,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      case "SetFilters" :
          return {
                  loadingCorrelationData: state.loadingCorrelationData,
                  toggleFilter: state.toggleFilter,
                  filterPills: state.filterPills,
                  filters: x._0,
                  currentFilter: state.currentFilter,
                  correlationData: state.correlationData
                };
      
    }
  }
  return {
          loadingCorrelationData: true,
          toggleFilter: state.toggleFilter,
          filterPills: state.filterPills,
          filters: state.filters,
          currentFilter: state.currentFilter,
          correlationData: state.correlationData
        };
}

var initialState_correlationData = {
  categories: /* [] */0,
  data: null
};

var initialState = {
  loadingCorrelationData: true,
  toggleFilter: false,
  filterPills: /* [] */0,
  filters: /* [] */0,
  currentFilter: 0,
  correlationData: initialState_correlationData
};

function InsightsCorrelation(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var fetchVisualizations = function (param) {
    Js_promise.then_((function (xs) {
            return Promise.resolve(setTimeout((function (param) {
                              Curry._1(dispatch, {
                                    TAG: "FetchedCorrelationData",
                                    _0: xs
                                  });
                            }), Utils$ReactHooksTemplate.timeout));
          }), Js_promise.then_((function (xs) {
                console.log(xs);
                return Promise.resolve(xs);
              }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/insights/correlation_data", (function (json) {
                    return {
                            categories: Json_decode.field("categories", (function (param) {
                                    return Json_decode.list(Json_decode.string, param);
                                  }), json),
                            data: Belt_Option.getWithDefault(Js_json.decodeObject(json), {})["data"]
                          };
                  }))));
  };
  React.useEffect((function (param) {
          fetchVisualizations();
        }), []);
  var onApplyFilter = function (param) {
    fetchVisualizations();
  };
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, {
          TAG: "SetFilters",
          _0: state.filters
        });
  };
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          state.toggleFilter ? JsxRuntime.jsx(InsightsFilters$ReactHooksTemplate.make, {
                                  onClose: toggleFilter,
                                  onApply: onApplyFilter,
                                  showDateFilter: false,
                                  showFilterPills: false,
                                  correlation: true
                                }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: "Active Filters",
                                                className: "flex items-center font-normal text-sm h-8"
                                              }),
                                          JsxRuntime.jsx(InsightsFilters$ReactHooksTemplate.make, {
                                                onClose: toggleFilter,
                                                onApply: onApplyFilter,
                                                showDateFilter: false,
                                                showFilterPills: true,
                                                correlation: true
                                              })
                                        ],
                                        className: "flex flex-wrap gap-2"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-2-px",
                                                      src: Image$ReactHooksTemplate.filterButton
                                                    }),
                                                "Filters"
                                              ],
                                              className: "bg-ghostwhite border border-gray-400\n                              shadow-inner flex rounded py-2 px-3 text-xs",
                                              id: "filters",
                                              onClick: (function (param) {
                                                  toggleFilter();
                                                })
                                            }),
                                        className: "float-right"
                                      })
                                ],
                                className: "px-16-px flex justify-between pb-20-px"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      className: "w-3 bg-red-600 h-10 mr-2"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "CORRELATION MATRIX",
                                                      className: "text-lg font-extrabold"
                                                    })
                                              ],
                                              className: "flex items-center"
                                            }),
                                        className: "w-full border mb-2 bg-white h-10"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Highcharts$ReactHooksTemplate.HeatmapBinding.make, {
                                              mapHeight: "30%",
                                              categories: $$Array.of_list(state.correlationData.categories),
                                              data: state.correlationData.data
                                            }),
                                        className: "border bg-white flex justify-center p-2 h-full w-full"
                                      })
                                ],
                                className: "flex flex-col pb-20-px"
                              })
                        ],
                        className: "p-20-px bg-porcelain"
                      }))
            });
}

var make = InsightsCorrelation;

exports.reducer = reducer;
exports.initialState = initialState;
exports.make = make;
/* initialState Not a pure module */
